import React, { useState } from "react";

//core-ui
import {
  CTable,
  CTableRow,
  CTableBody,
  CTableHead,
  CTableHeaderCell
} from "@coreui/react";

import useAxios from "../hooks/useAxios";
import axiosInstance from "../apis/gvmdesk";

import VacationTableRow from "./VacationTableRow";
import PopupTransfer from "../components/PopupTransfer";
import PopupLiberate from "../components/PopupLiberate";
import LoadingCenter from "../components/LoadingCenter";

const VacationList = props => {
  const [transfer, setTransfer] = useState(false);
  const [liberate, setLiberate] = useState(false);
  const [currentAdmin, setCurrentAdmin] = useState(null);

  const [admins, setAdmins, adminsLoading, adminsError, adminsRefetch] = useAxios({
    axiosInstance,
    method: "GET",
    url: "/admins/list"
  });

  const handleSetCurrentAdmin = (e, admin) => {
    e.preventDefault();
    setCurrentAdmin(admin);
    setTransfer(!transfer);
  }

  const handleSetLiberate = (e, admin) => {
    e.preventDefault();
    setCurrentAdmin(admin);
    setLiberate(!liberate);
  }

  return (
    <div className="d-flex flex-column">
      <div className="header border-bottom border-top-right-radius-8">
        <span>Ferramenta de férias</span>
      </div>

      <div className="dashboard__container">
        <PopupTransfer admin={currentAdmin} trigger={transfer} setTrigger={setTransfer} />
        <PopupLiberate admin={currentAdmin} trigger={liberate} setTrigger={setLiberate} />

        {adminsLoading && <LoadingCenter />}

        {!adminsLoading && <CTable striped>
          <CTableHead>
            <CTableRow>
              <CTableHeaderCell scope="col" style={{ width: "32px" }}></CTableHeaderCell>
              <CTableHeaderCell scope="col" style={{ width: "" }}>
                <span className="text-color">Nome</span>
              </CTableHeaderCell>
              <CTableHeaderCell scope="col" style={{ width: "48px" }}></CTableHeaderCell>
            </CTableRow>
          </CTableHead>
          <CTableBody>
            {admins?.map(admin => {
              return (
                <VacationTableRow key={admin.id} admin={admin} setAdmin={handleSetCurrentAdmin} setLiberate={handleSetLiberate} />
              );
            })}
          </CTableBody>
        </CTable>}
      </div>
    </div>
  );
}

export default VacationList;